import {
  base_colorContentBorder,
  base_colorRaisedSurface,
  cta_buttonPrimaryText,
  text_colorTextPrimary,
  text_colorTextSecondary,
} from 'ext-ui/style/colors'
import { spacing } from 'ext-ui/style/spacing'
import {
  font_family_weight_medium,
  font_family_weight_regular,
} from 'ext-ui/style/typography'
import { css } from 'styled-components'

export default css`
  width: min(100%, 790px);
  display: grid;
  grid-template-columns: minmax(0, 415fr) minmax(0, 375fr);
  min-height: 300px;
  overflow: hidden;
  border: 1px solid ${base_colorContentBorder};
  border-radius: ${spacing(5.5)};
  background: ${base_colorRaisedSurface};
  box-shadow: 0 ${spacing(4.5)} ${spacing(12.5)} -${spacing(5.5)}
    ${text_colorTextPrimary}38;

  .PromotionSavingsHero-copy {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    gap: ${spacing(4)};
    padding: ${spacing(9)} ${spacing(10)};
  }

  .PromotionSavingsHero-brand {
    display: flex;
    align-items: center;
    gap: ${spacing(2)};
  }

  .PromotionSavingsHero-logo {
    width: 27px;
    height: 16px;
    object-fit: contain;
  }

  .PromotionSavingsHero-eyebrow {
    color: ${text_colorTextSecondary};
    font-family: ${font_family_weight_medium};
    font-size: 11px;
    font-weight: 500;
    line-height: normal;
    letter-spacing: 1.6px;
  }

  .PromotionSavingsHero-headline {
    color: ${text_colorTextPrimary};
    font-family: ${font_family_weight_medium};
    font-size: 18px;
    font-weight: 500;
    line-height: normal;
  }

  .PromotionSavingsHero-description {
    color: ${text_colorTextSecondary};
    font-family: ${font_family_weight_regular};
    font-size: 14px;
    font-weight: 400;
    line-height: 20px;
  }

  .PromotionSavingsHero-pricing {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    gap: 18px;
    padding: ${spacing(8)} ${spacing(7)} ${spacing(7)};
    background:
      radial-gradient(
        62.5% 41.67% at 25% 125%,
        rgba(255, 255, 255, 0.18) 0%,
        rgba(255, 255, 255, 0) 100%
      ),
      linear-gradient(90deg, #4489f9 0%, #2fb899 100%);
  }

  .PromotionSavingsHero-firstYearPriceLabel {
    display: flex;
    align-items: center;
    gap: 6px;
    color: ${cta_buttonPrimaryText};
    font-family: ${font_family_weight_medium};
    font-size: 11px;
    font-weight: 500;
    line-height: normal;
    letter-spacing: 1.4px;
    text-transform: uppercase;

    img {
      width: 11px;
      height: 11px;
    }
  }

  .PromotionSavingsHero-firstYearPriceSummary {
    display: flex;
    flex-direction: column;
    gap: ${spacing(1)};
  }

  .PromotionSavingsHero-firstYearPriceAmount {
    color: ${cta_buttonPrimaryText};
    font-family: ${font_family_weight_medium};
    font-size: 48px;
    font-weight: 700;
    line-height: normal;
    white-space: nowrap;
  }

  .PromotionSavingsHero-savingsDetail {
    color: ${cta_buttonPrimaryText};
    font-family: ${font_family_weight_regular};
    font-size: 13px;
    font-weight: 400;
    line-height: normal;
  }

  .PromotionSavingsHero-divider {
    width: 100%;
    min-height: 1px;
    background: rgba(255, 255, 255, 0.15);
  }

  .PromotionSavingsHero-paymentSummary {
    color: ${cta_buttonPrimaryText};
    font-family: ${font_family_weight_medium};
    font-size: 13px;
    font-weight: 500;
    line-height: normal;
  }

  .PromotionSavingsHero-discountedPrice,
  .PromotionSavingsHero-standardPrice {
    color: ${cta_buttonPrimaryText};
    font-family: ${font_family_weight_medium};
  }

  .PromotionSavingsHero-freeSeats {
    display: flex;
    align-items: center;
    align-self: flex-start;
    gap: ${spacing(1)};
    padding: ${spacing(1)} 10px;
    color: ${cta_buttonPrimaryText};
    background: rgba(255, 255, 255, 0.16);
    border: 1px solid rgba(255, 255, 255, 0.22);
    border-radius: 999px;
    font-family: ${font_family_weight_medium};
    font-size: 11px;
    font-weight: 700;
    line-height: normal;

    img {
      width: 10px;
      height: 10px;
    }
  }

  @media (max-width: 720px) {
    grid-template-columns: 1fr;
    min-height: 0;

    .PromotionSavingsHero-copy,
    .PromotionSavingsHero-pricing {
      padding: ${spacing(6)};
    }

    .PromotionSavingsHero-headline {
      font-size: 18px;
      line-height: normal;
    }

    .PromotionSavingsHero-firstYearPriceAmount {
      font-size: 40px;
      line-height: normal;
    }
  }
`
